import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {SelectModule} from 'ng-select';
import {CommonComponentsModule} from '../../../common/components';
import {DashboardPipesModule} from '../core/pipes';
import {SHARED_API_PROVIDERS} from './api'
import {BackButtonComponent} from './back-button/back-button';
import {BO_TAB_COMPONENTS} from './bo-tabs';
import {CARD_BOX_COMPONENTS} from './card-box';
import {COMBO_SEARCH_COMPONENT} from './combo-search';
import {DATA_ITEM_COMPONENTS} from './data-item';
import {DIRECTIVES} from './directives';
import {DRAG_AND_DROP_COMPONENTS} from './drag-and-drop';
import {DROPDOWN_COMPONENTS} from './dropdown';
import {FILTER_COMPONENTS, FILTER_PROVIDERS} from './filter';
import {TRANSFER_ICONS} from './icons';
import {DateRangePickerModule, IbanControlDirective} from './input';
import {LEAVE_BLOCKABLE_COMPONENTS, LEAVE_BLOCKABLE_PROVIDERS} from './leave-block';
import {MODAL_POPUP_COMPONENTS, MODAL_POPUP_PROVIDERS} from './modal';
import {NAVIGATION_SERVICES} from './navigation';
import {PaginationComponent} from './pagination';
import {PIPES} from './pipes';
import {REVENUE_DISTRIBUTION_PROVIDERS, REVENUE_DISTRIBUTION_SETTINGS_COMPONENTS} from './revenue';
import {SuccessPageComponent} from './success-page/success.component';
import {TABLE_COMPONENTS} from './table';
import {TransferIconFactory} from './transfer.icon.factory';
import {CUSTOM_COMPONENTS, CUSTOM_PROVIDERS} from './components';
import {CUSTOM_ELEMENTS} from './elements';
import {ACCOUNT_STATE_LOG_COMPONENTS} from './account-state-log';
import {SHARED_CUSTOMER_ACCOUNT_COMPONENTS} from './customer-account';
import {ChipComponent} from './chip/chip.component';
import {MatChipsModule} from '@angular/material/chips';
import {MatIconModule} from '@angular/material/icon';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {BOHttpModule} from "../core/http";
import {RoleService} from "../core/security";
import {SHARED_PROFILE_USER_COMPONENTS} from "./profile-user";
import {MatMenuModule} from "@angular/material/menu";
import {OPTION_DIALOG_COMPONENTS} from './option-dialog';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        CommonComponentsModule,
        DateRangePickerModule,
        SelectModule,
        RouterModule,
        DashboardPipesModule,
        MatChipsModule,
        MatIconModule,
        MatAutocompleteModule,
        MatSelectModule,
        MatInputModule,
        BOHttpModule,
        MatMenuModule
    ],
    providers: [
        ...SHARED_API_PROVIDERS,
        ...FILTER_PROVIDERS,
        ...LEAVE_BLOCKABLE_PROVIDERS,
        ...MODAL_POPUP_PROVIDERS,
        ...NAVIGATION_SERVICES,
        ...REVENUE_DISTRIBUTION_PROVIDERS,
        ...CUSTOM_PROVIDERS,
        RoleService
    ],
    declarations: [
        ...COMBO_SEARCH_COMPONENT,
        ...CARD_BOX_COMPONENTS,
        ...FILTER_COMPONENTS,
        ...DATA_ITEM_COMPONENTS,
        ...LEAVE_BLOCKABLE_COMPONENTS,
        ...MODAL_POPUP_COMPONENTS,
        ...TABLE_COMPONENTS,
        ...PIPES,
        ...DRAG_AND_DROP_COMPONENTS,
        ...DIRECTIVES,
        ...DROPDOWN_COMPONENTS,
        ...REVENUE_DISTRIBUTION_SETTINGS_COMPONENTS,
        ...BO_TAB_COMPONENTS,
        ...TRANSFER_ICONS,
        ...CUSTOM_COMPONENTS,
        ...SHARED_CUSTOMER_ACCOUNT_COMPONENTS,
        ...SHARED_PROFILE_USER_COMPONENTS,
        ...CUSTOM_ELEMENTS,
        ...OPTION_DIALOG_COMPONENTS,
        SuccessPageComponent,
        PaginationComponent,
        BackButtonComponent,
        TransferIconFactory,
        IbanControlDirective,
        ...ACCOUNT_STATE_LOG_COMPONENTS,
        ChipComponent
    ],
    exports: [
        ...COMBO_SEARCH_COMPONENT,
        ...CARD_BOX_COMPONENTS,
        ...FILTER_COMPONENTS,
        ...DATA_ITEM_COMPONENTS,
        ...LEAVE_BLOCKABLE_COMPONENTS,
        ...TABLE_COMPONENTS,
        ...PIPES,
        ...MODAL_POPUP_COMPONENTS,
        ...DRAG_AND_DROP_COMPONENTS,
        ...DIRECTIVES,
        ...DROPDOWN_COMPONENTS,
        ...REVENUE_DISTRIBUTION_SETTINGS_COMPONENTS,
        ...BO_TAB_COMPONENTS,
        ...TRANSFER_ICONS,
        ...CUSTOM_COMPONENTS,
        ...CUSTOM_ELEMENTS,
        ...SHARED_CUSTOMER_ACCOUNT_COMPONENTS,
        ...SHARED_PROFILE_USER_COMPONENTS,
        ...OPTION_DIALOG_COMPONENTS,
        PaginationComponent,
        SuccessPageComponent,
        BackButtonComponent,
        TransferIconFactory,
        IbanControlDirective,
        ChipComponent,

        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SelectModule,
        TranslateModule,
        DateRangePickerModule,
        CommonComponentsModule,
        DashboardPipesModule,
        ...ACCOUNT_STATE_LOG_COMPONENTS
    ],
    entryComponents: [
        TransferIconFactory,
        ...TRANSFER_ICONS
    ]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule,
            providers: [
                ...SHARED_API_PROVIDERS,
                ...FILTER_PROVIDERS,
                ...LEAVE_BLOCKABLE_PROVIDERS,
                ...MODAL_POPUP_PROVIDERS,
                ...NAVIGATION_SERVICES,
                ...REVENUE_DISTRIBUTION_PROVIDERS
            ]
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/shared.module.ts